import type { SortValue, StatusValue } from './api';

export type SortOption = { value: SortValue; label: string };
export type StatusOption = { value: StatusValue; label: string };

export const SORT_OPTIONS: SortOption[] = [
  { value: 'volume24hr', label: '24hr Volume' },
  { value: 'volume', label: 'Total Volume' },
  { value: 'liquidity', label: 'Liquidity' },
  { value: 'featuredOrder', label: 'Featured' },
  { value: 'startDate', label: 'Recently Started' },
  { value: 'endDate', label: 'Ending Soon' },
  { value: 'competitive', label: 'Competitive' },
];

export const STATUS_OPTIONS: StatusOption[] = [
  { value: 'active', label: 'Active' },
  { value: 'resolved', label: 'Resolved' },
];
